export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-color/src/math.js
// module id = Ip0L
// module chunks = 0